<template>
  <div class="via-local-header-row" v-if="localIsLoaded">
    <div
      class="via-local-header-col"
      :class="state === 'online' ? 'local-active' : ''"
      @click="$emit('localStateChange', 'online')"
    >
      <span class="local-state-text">{{ buyOnlineText }}</span>
    </div>
    <div
      class="via-local-header-col"
      :class="state == 'offline' ? 'local-active' : ''"
      @click="$emit('localStateChange', 'offline')"
    >
      <span class="local-state-text">{{ findAStoreText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'localOnlineOfflineTab',
  props: {
    state: {
      type: String,
      default: '',
    },
    findAStoreText: { type: String, default: '' },
    buyOnlineText: { type: String, default: '' },
    localIsLoaded: { type: Boolean, default: false },
  },
}
</script>

<style>
.via-local-header-row {
  display: grid;
  grid-template-columns: 50% 50%;
  transition: 0.5s;
  padding: 8px 0;
}

.via-local-header-col {
  text-align: center;
  padding: 0.5em 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}

.local-state-text {
  padding-bottom: 3px;
}

/* .local-active {
  color: red;
} */

.local-active .local-state-text {
  border-bottom: 2px solid #464646;
}
</style>
